import {COLUMN_HEADER} from './table';

export enum TABLE_TYPE {
  MASTER_TYPES = 'MASTER_TYPES',
  LANGUAGES = 'LANGUAGES',
  MASTER_LANGUAGES = 'MASTER_LANGUAGES',
  OPERATING_SYSTEMS = 'OPERATING_SYSTEMS',
  MASTER_OPERATING_SYSTEMS = 'MASTER_OPERATING_SYSTEMS',
  TECHNOLOGIES = 'TECHNOLOGIES',
  MASTER_TECHNOLOGIES = 'MASTER_TECHNOLOGIES',
  PRODUCTS = 'PRODUCTS',
  MASTER_PRODUCTS = 'MASTER_PRODUCTS',
  COMPONENTS = 'COMPONENTS',
  MASTER_COMPONENTS = 'MASTER_COMPONENTS',
  REPORT_PRODUCTS = 'REPORT_PRODUCTS',
  PRODUCT_VERSIONS = 'PRODUCT_VERSIONS',
  HISTORY = 'HISTORY',
  EMAIL_REPORT = 'EMAIL_REPORT'
}

export const COLUMN_CONFIG = {
  POSITIVE_FEEDBACK: {
    header: COLUMN_HEADER.POSITIVE_FEEDBACK,
    headerTooltip: COLUMN_HEADER.POSITIVE_FEEDBACK,
    field: 'positiveFeedbackCount',
    editable: false,
    width: '75px',
  },
  NEGATIVE_FEEDBACK: {
    header: COLUMN_HEADER.NEGATIVE_FEEDBACK,
    headerTooltip: COLUMN_HEADER.NEGATIVE_FEEDBACK,
    field: 'negativeFeedbackCount',
    editable: false,
    width: '75px',
  },
  VIEWS: {
    header: COLUMN_HEADER.VIEWS,
    headerTooltip: COLUMN_HEADER.VIEWS_HEADER_TOOLTIP,
    field: 'clientViewCount',
    editable: false,
    width: '100px',
  },
  VIEWS_EMPTY: {
    header: COLUMN_HEADER.VIEWS_EMPTY,
    headerTooltip: COLUMN_HEADER.VIEWS_EMPTY_HEADER_TOOLTIP,
    field: 'clientEmptyViewCount',
    editable: false,
    width: '100px',
  },
  TABS: {
    header: COLUMN_HEADER.TABS,
    headerTooltip: COLUMN_HEADER.TABS_HEADER_TOOLTIP,
    field: 'productFillInTabsCount',
    editable: false,
    width: '85px',
  },
  NAME: {
    header: COLUMN_HEADER.NAME,
    headerTooltip: COLUMN_HEADER.NAME,
    field: 'name',
    editable: false,
  },
  VERSION: {
    header: COLUMN_HEADER.VERSION,
    headerTooltip: COLUMN_HEADER.VERSION,
    field: 'version',
    editable: false,
  },
  SP_FP_PATCH: {
    header: COLUMN_HEADER.SP_FP_PATCH,
    headerTooltip: COLUMN_HEADER.SP_FP_PATCH,
    field: 'servicePackName',
    editable: false,
  },
  SMART_NUMBER: {
    header: COLUMN_HEADER.SMART_NUMBER,
    headerTooltip: COLUMN_HEADER.SMART_NUMBER,
    field: 'smartNumber',
    width: '140px',
    editable: false,
  },
  PRODUCT_TYPE: {
    header: COLUMN_HEADER.PRODUCT_TYPE,
    headerTooltip: COLUMN_HEADER.PRODUCT_TYPE,
    field: 'productType',
    width: '140px',
    editable: false,
  },
  EDITOR: {
    header: COLUMN_HEADER.EDITOR,
    headerTooltip: COLUMN_HEADER.EDITOR,
    field: 'lastModifiedBy',
    editable: false,
    width: '100px'
  },
  PRODUCT_STATUS: {
    header: COLUMN_HEADER.PRODUCT_STATUS,
    headerTooltip: COLUMN_HEADER.PRODUCT_STATUS,
    field: 'productStatus',
    editable: false,
    width: '160px',
  },
  PUBLISHING_STATUS: {
    header: COLUMN_HEADER.PUBLISHING_STATUS,
    headerTooltip: COLUMN_HEADER.PUBLISHING_STATUS,
    field: 'publishingStatus',
    editable: false,
    width: '160px',
  },
  PUBLISHED_DATA: {
    header: COLUMN_HEADER.PUBLISHED_DATA,
    headerTooltip: COLUMN_HEADER.PUBLISHED_DATA,
    field: 'hasPublishedVersion',
    editable: false,
    width: '100px',
  },
  SUB_TYPE: {
    header: COLUMN_HEADER.SUB_TYPE,
    headerTooltip: COLUMN_HEADER.SUB_TYPE,
    field: 'productSubType',
    editable: false,
  },
  BUSINESS_UNIT: {
    header: COLUMN_HEADER.BUSINESS_UNIT,
    headerTooltip: COLUMN_HEADER.BUSINESS_UNIT,
    field: 'baseBusinessUnit',
    editable: false,
  },
  PRODUCT_LINE: {
    header: COLUMN_HEADER.PRODUCT_LINE,
    headerTooltip: COLUMN_HEADER.PRODUCT_LINE,
    field: 'baseProductLine',
    editable: false,
  },
  PRODUCT_FAMILY: {
    header: COLUMN_HEADER.PRODUCT_FAMILY,
    headerTooltip: COLUMN_HEADER.PRODUCT_FAMILY,
    field: 'baseProductFamily',
    editable: false,
  },
  RELEASE_DATE: {
    header: COLUMN_HEADER.RELEASE_DATE,
    headerTooltip: COLUMN_HEADER.RELEASE_DATE,
    field: 'availabityDate',
    editable: false,
  },
  FULL_SUPP_END_DATE: {
    header: COLUMN_HEADER.FULL_SUPP_END_DATE,
    headerTooltip: COLUMN_HEADER.FULL_SUPP_END_DATE,
    field: 'fullSuppEndDate',
    editable: false,
  },
  END_OF_VERSION_SUPPORT: {
    header: COLUMN_HEADER.END_OF_VERSION_SUPPORT,
    headerTooltip: COLUMN_HEADER.END_OF_VERSION_SUPPORT,
    field: 'projObsDate',
    editable: false,
  },
  CMP_TYPE_NAME: {
    header: COLUMN_HEADER.NAME,
    field: 'cmpTypeName',
    editable: false,
  },
  CMP_NAME: {
    header: COLUMN_HEADER.NAME,
    field: 'cmpName',
    editable: false
  },
  CMP_VERSION: {
    header: COLUMN_HEADER.VERSION,
    field: 'cmpVersion',
    editable: false,
  },
  CMP_VENDOR: {
    header: COLUMN_HEADER.VENDOR,
    field: 'supplierName',
  },
  CMP_ARCHITECTURE: {
    header: COLUMN_HEADER.ARCHITECTURE,
    field: 'cmpArchitecture',
    editable: false,
  },
  CMP_TYPE: {
    header: COLUMN_HEADER.TYPE,
    field: 'cmpTypes',
    width: '500px'
  },
  PROD_INST_CMP_TYPE: {
    header: COLUMN_HEADER.TYPE,
    field: 'productInstComponentType.cmpTypeName'
  },
  CMP_DB_NOTES: {
    header: COLUMN_HEADER.DB_NOTES,
    field: 'note.content',
    editable: false,
    filterable: false,
    sortable: false,
    width: '90px',
  },
  OS_NAME: {
    header: COLUMN_HEADER.NAME,
    field: 'osName',
    editable: false
  },
  OS_VERSION: {
    header: COLUMN_HEADER.VERSION,
    field: 'osVersion',
    editable: false
  },
  OS_VENDOR: {
    header: COLUMN_HEADER.VENDOR,
    field: 'osVendor',
    editable: false
  },
  OS_ARCHITECTURE: {
    header: COLUMN_HEADER.ARCH,
    field: 'osArchitecture',
    editable: false
  },
  OS_FAMILY: {
    header: COLUMN_HEADER.FAMILY,
    field: 'osFamily',
    editable: false
  },
  OS_HW_NAME: {
    header: COLUMN_HEADER.HW_NAME,
    field: 'osHwName',
    editable: false
  },
  OS_HW_ARCHITECTURE: {
    header: COLUMN_HEADER.HW_ARCH,
    field: 'osHwArchitecture',
    editable: false
  },
  OS_NOTES: {
    header: COLUMN_HEADER.OS_NOTES,
    field: '',
    editable: false,
    filterable: false,
    sortable: false,
    width: '90px',
  },
  OS_DETAILS: {
    header: COLUMN_HEADER.OS_DETAILS,
    field: '',
    editable: false,
    filterable: false,
    sortable: false,
    width: '90px',
  },
  HISTORY_USER: {
    header: COLUMN_HEADER.USER,
    field: 'user.username',
    width: '140px'
  },
  HISTORY_ACTIVITY: {
    header: COLUMN_HEADER.ACTIVITY,
    field: 'action',
    width: '100px'
  },
  HISTORY_TYPE: {
    header: COLUMN_HEADER.TYPE,
    field: 'itemType',
    width: '100px'
  },
  HISTORY_PARENT: {
    header: COLUMN_HEADER.PARENT_NAME
  },
  HISTORY_NAME: {
    header: COLUMN_HEADER.NAME
  },
  HISTORY_DESCR: {
    header: 'DESCR',
    field: 'actionItemDescription'
  },
  HISTORY_DATE: {
    header: COLUMN_HEADER.DATE,
    field: 'modificationDate',
    width: '200px'
  }
};
